const printAreasByItemNumber = (itemNr: number) => {
    let areaDef = '';
    if (itemNr < 3) {
        for (let i = 0; i < itemNr; i++) {
            areaDef += `StepItem${i} `;
        }

        return areaDef;
    }
    const maxItemColumns = itemNr % 4 === 3 || itemNr % 4 === 0 ? 4 : 3;

    for (let i = 0; i < itemNr / maxItemColumns; i++) {
        const itemsLeft = itemNr - maxItemColumns * i;
        let maxColumnsInRow = maxItemColumns * 2;
        if (i > 0) {
            areaDef += '\n';
        }
        areaDef += '"';
        if (itemsLeft < maxItemColumns) {
            areaDef += '. ';
            maxColumnsInRow -= 2;
        }
        for (let j = 0; j < maxColumnsInRow; j++) {
            areaDef += `StepItem${Math.trunc(j / 2) + i * maxItemColumns} `;
        }
        if (itemsLeft < maxItemColumns) {
            areaDef += '.';
        }

        areaDef += '"';
    }

    return areaDef;
};

export default printAreasByItemNumber;
